import React from 'react';

const ThreeDays = () => {
  const now = new Date();
  // Add 3 days: 3 days * 24 hours/day * 60 minutes/hour * 60 seconds/minute * 1000ms/second
  const threeDaysFromNow = new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000);

  // Format the date as desired; using toLocaleString for a simple default format.
  const formattedDateTime = threeDaysFromNow.toLocaleDateString();

  return <strong>{formattedDateTime}</strong>;
};

export default ThreeDays;